<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  setInfo2,
  setInfo3,
  copySetInfo3,
  copySetInfo2,
  setArray,
  zoomStyle
} from "./config";
import printFooter from "./print-footer.vue";
import printHead from "./print-head.vue";
@Component({
  name: "normal-print",
  components: { printHead, printFooter },
})
export default class App extends Vue {
  info = {
    table1: {},
    table2: {},
    table3: {},
    table4: {},
  };
  defailInfo = {};
  list = [];
  businessList = [];
  POST_DEBIT_GENERAL_ORDER_PRINT() {
    return new Promise((resolve, reject) => {
      this.$apis.autoAPi
        .POST_DEBIT_GENERAL_ORDER_PRINT({
          id: this.$route.query.id,
          modifyCode: this.$store.state.userInfo.loginId,
          modifyName: this.$store.state.userInfo.adminUserName
        })
        .done((res) => {
          resolve(res);
        })
        .fail((err) => {
          reject();
        });
    });
  }
  mounted() {
    this.POST_DEBIT_GENERAL_ORDER_PRINT()
      .then((res) => {
        this.defailInfo = res.data;
        let flag = 10;
        let total = {
          storageGenuineTotal: 0,
          storageSecondTotal: 0,
          storageInferiorTotal: 0,
          storageTotal: 0,
          debitPriceTotal: 0,
          debitTotal: 0,
          applyDebitPriceTotal: 0,
          applyDebitTotal: 0,
          applyFreeChargeTotal: 0,
        };
        // for (let index = 0; index < 100; index++) {
        //   res.data.itemVOList.push(res.data.itemVOList[0]);
        // }
        // const array = res.data.itemVOList.map(setItemList);
        const spliceArray = [];
        const businessSpliceArray = [];
        res.data.itemVOList.forEach((item, $index) => {
          let i = 0;
          total.storageGenuineTotal += Number(item.storageGenuineNum || 0);
          total.storageSecondTotal += Number(item.storageSecondNum || 0);
          total.storageInferiorTotal += Number(item.storageInferiorNum || 0);
          total.storageTotal += Number(item.storageTotalNum || 0);
          total.debitPriceTotal += Number(item.debitPrice || 0);
          total.debitTotal += Number(item.debitTotal || 0);
          total.applyDebitPriceTotal += Number(item.applyDebitPrice || 0);
          total.applyDebitTotal += Number(item.applyDebitTotal || 0);
          total.applyFreeChargeTotal += Number(item.applyFreeCharge || 0);
          if ($index <= 10) {
            i = parseInt($index / 10);
          } else {
            i = parseInt($index / 11);
          }
          if (!spliceArray[i]) spliceArray[i] = [];
          spliceArray[i].push(item);
        });
        res.data.businessVOList.forEach((item, $index) => {
          let i = 0;
          if ($index <= 10) {
            i = parseInt($index / 10);
          } else {
            i = parseInt($index / 11);
          }
          if (!businessSpliceArray[i]) businessSpliceArray[i] = [];
          businessSpliceArray[i].push(item);
        });

        this.list = spliceArray.map((item, index) => {
          // 表头
          const setInfo2Info = setInfo2();
          // 设置内容
          setInfo2Info.children = setArray(
            setInfo2Info.children.concat(item.map(setItemList)),
            12,
            copySetInfo2,
            index
          );
          return {
            table2: setInfo2Info
          };
        });
        this.list.forEach((item, index) => {
          if(index >= 1) {
            item.table2.children.splice(0,1)
          }
        })
        console.log('list:', this.list)
        this.businessList = businessSpliceArray.map((item, index) => {
          // 表头
          const setInfo3Info = setInfo3();
          // 设置内容
          setInfo3Info.children = setArray(
            setInfo3Info.children.concat(item.map(setItemList2)),
            12,
            copySetInfo3,
            index
          );

          return {
            table3: setInfo3Info,
          };
        });
        // 合计
        this.list[this.list.length - 1].table2.children.push(
          setTotalItem(total)
        );
      })
      .catch((err) => {});

    function setItemList(item) {
      return {
        style: {
          height: "16mm",
          flex: "none",
        },
        children: [
          {
            textStyle: zoomStyle,
            width: null,
            text: item.materialCode,
            propsName: "colorName",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.series,
            propsName: "series",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.poType,
            propsName: "standard",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.productName,
            propsName: "attrSpecificationsAndDensity",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.contractTerm
              ? new Date(item.contractTerm).toLocaleDateString()
              : "",
            propsName: "attrConstituent",
          },
          // {
          //   textStyle: zoomStyle,
          //   width: null,
          //   text: item.productDate,
          //   propsName: "productDate",
          // },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.warehouseDate
              ? new Date(item.warehouseDate).toLocaleDateString()
              : "",
            propsName: "unit",
          },
          {
            textStyle: zoomStyle,
            width: null,
            style: {
              flexDirection: "row",
              flex: "none",
              width: "10%",
              // height: '24mm'
            },
            // children: [
            // {
            // 	width: null,
            // 	text: '涉扣款物料'
            // },
            // {
            children: [
              {
                textStyle: zoomStyle,
                text: item.debitMaterialCode,
                propsName: "taxFinishPrice1",
              },
              {
                textStyle: zoomStyle,
                text: item.debitVendor,
                propsName: "taxFinishPrice2",
              },
              {
                textStyle: zoomStyle,
                text: item.debitContractTerm
                  ? new Date(item.debitContractTerm).toLocaleDateString()
                  : "",
                propsName: "taxFinishPrice3",
              },
              {
                textStyle: zoomStyle,
                text: item.debitWarehouseDate
                  ? new Date(item.debitWarehouseDate).toLocaleDateString()
                  : "",
                propsName: "taxFinishPrice3",
              },
            ],
            // 	}
            // ]
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.tagPrice,
            propsName: "templateCycle",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.fobPrice,
            propsName: "templateCycle",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.orderNum,
            propsName: "shipmentDate",
          },
          {
            width: null,
            style: {
              flexDirection: "row",
              flex: "none",
              width: "10%",
              // height: '24mm'
            },
            // contentStyle: { flex: "none", width: "20%" },
            // children: [
            // {
            // 	width: null,
            // 	text: '入仓数（件）'
            // },
            // {
            children: [
              {
                textStyle: zoomStyle,
                text: item.storageGenuineNum,
                propsName: "taxFinishPrice1",
              },
              {
                textStyle: zoomStyle,
                text: item.storageSecondNum,
                propsName: "taxFinishPrice2",
              },
              {
                textStyle: zoomStyle,
                text: item.storageInferiorNum,
                propsName: "taxFinishPrice2",
              },
              {
                textStyle: zoomStyle,
                text: item.storageTotalNum,
                propsName: "taxFinishPrice2",
              },
            ],
            // }
            // ]
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.debitCase,
            propsName: "shipmentDate",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.debitNum,
            propsName: "shipmentDate",
          },
          {
            width: null,
            style: {
              flexDirection: "row",
              flex: "none",
              width: "8%",
              // height: '24mm'
            },
            // contentStyle: { flex: "none", width: "20%" },
            // children: [
            // 	{
            // 		width: null,
            // 		text: '应扣款'
            // 	},
            // 	{
            children: [
              {
                textStyle: zoomStyle,
                text: item.debitPrice,
                propsName: "taxFinishPrice1",
              },
              {
                textStyle: zoomStyle,
                text: item.debitTotal,
                propsName: "taxFinishPrice2",
              },
              // ]
              // }
            ],
          },
          {
            width: null,
            style: {
              flexDirection: "row",
              flex: "none",
              width: "8%",
              // height: '24mm'
            },
            // contentStyle: { flex: "none", width: "20%" },
            // children: [
            // {
            // 	width: null,
            // 	text: '申请扣款'
            // },
            // {
            children: [
              {
                textStyle: zoomStyle,
                text: item.applyDebitPrice,
                propsName: "taxFinishPrice1",
              },
              {
                textStyle: zoomStyle,
                text: item.applyDebitTotal,
                propsName: "taxFinishPrice2",
              },
            ],
            // }
            // ]
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.applyFreeCharge,
            propsName: "shipmentDate",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.responsibleParty,
            propsName: "shipmentDate",
          },
          {
            style: {
              width: "40mm",
              flex: "none",
            },
            textStyle: zoomStyle,
            width: null,
            text: item.debitInfo,
          },
        ],
      };
    }

    function setItemList2(item) {
      return {
        style: {
          height: "32mm",
          flex: "none",
        },
        children: [
          {
            textStyle: zoomStyle,
            style: {
							width: "50mm",
							flex: "none"
						},
            width: null,
            text: item.materialCode,
            propsName: "colorName",
          },
          {
            textStyle: zoomStyle,
            style: {
							width: "80mm",
							flex: "none"
						},
            width: null,
            text: item.vendorRemark,
            propsName: "vendorMaterialCode",
          },
          {
            textStyle: zoomStyle,
            style: {
							width: "80mm",
							flex: "none"
						},
            width: null,
            text: item.merchandiserRemark,
            propsName: "vendorMaterialCode",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.businessRemark,
            propsName: "standard",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: item.productManagerRemark,
            propsName: "attrSpecificationsAndDensity",
          },
          // {
          //   textStyle: {
          //     fontSize: "10px",
          //     transform: "scale(0.6)",
          //     width: "160%",
          //   },
          //   width: null,
          //   text: item.statisticalExaminerRemark,
          //   propsName: "attrSpecificationsAndDensity",
          // },
          {
            textStyle: zoomStyle,
            width: "60mm",
            text: item.debitInfo,
            propsName: "attrSpecificationsAndDensity",
          },
        ],
      };
    }

    function setTotalItem(item) {
      return {
        style: {
          height: "12mm",
          flex: "none",
        },
        children: [
          {
            textStyle: {
              ...zoomStyle,
              fontWeight: "500",
            },
            width: null,
            text: `合计`,
            propsName: "colorName",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: ``,
            propsName: "vendorMaterialCode",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: ``,
            propsName: "standard",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: ``,
            propsName: "attrSpecificationsAndDensity",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: ``,
            propsName: "attrConstituent",
          },
          // {
          //   textStyle: zoomStyle,
          //   width: null,
          //   text: ``,
          //   propsName: "productDate",
          // },
          {
            textStyle: zoomStyle,
            width: null,
            text: ``,
            propsName: "unit",
          },
          {
            textStyle: zoomStyle,
            width: null,
            style: {
              flexDirection: "row",
              flex: "none",
              width: "10%",
              // height: '24mm'
            },
            // children: [
            // {
            // 	width: null,
            // 	text: '涉扣款物料'
            // },
            // {
            children: [
              {
                textStyle: zoomStyle,
                text: ``,
                propsName: "taxFinishPrice1",
              },
              {
                textStyle: zoomStyle,
                text: ``,
                propsName: "taxFinishPrice2",
              },
              {
                textStyle: zoomStyle,
                text: ``,
                propsName: "taxFinishPrice3",
              },
              {
                textStyle: zoomStyle,
                text: ``,
                propsName: "taxFinishPrice3",
              },
            ],
            // 	}
            // ]
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: ``,
            propsName: "templateCycle",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: ``,
            propsName: "templateCycle",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: ``,
            propsName: "shipmentDate",
          },
          {
            width: null,
            style: {
              flexDirection: "row",
              flex: "none",
              width: "10%",
              // height: '24mm'
            },
            // contentStyle: { flex: "none", width: "20%" },
            // children: [
            // {
            // 	width: null,
            // 	text: '入仓数（件）'
            // },
            // {
            children: [
              {
                textStyle: zoomStyle,
                text: item.storageGenuineTotal,
                propsName: "taxFinishPrice1",
              },
              {
                textStyle: zoomStyle,
                text: item.storageSecondTotal,
                propsName: "taxFinishPrice2",
              },
              {
                textStyle: zoomStyle,
                text: item.storageInferiorTotal,
                propsName: "taxFinishPrice2",
              },
              {
                textStyle: zoomStyle,
                text: item.storageTotal,
                propsName: "taxFinishPrice2",
              },
            ],
            // }
            // ]
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: ``,
            propsName: "shipmentDate",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: ``,
            propsName: "shipmentDate",
          },
          {
            width: null,
            style: {
              flexDirection: "row",
              flex: "none",
              width: "8%",
              // height: '24mm'
            },
            // contentStyle: { flex: "none", width: "20%" },
            // children: [
            // 	{
            // 		width: null,
            // 		text: '应扣款'
            // 	},
            // 	{
            children: [
              {
                textStyle: zoomStyle,
                text: (item.debitPriceTotal || 0).toFixed(2),
                propsName: "taxFinishPrice1",
              },
              {
                textStyle: zoomStyle,
                text: (item.debitTotal || 0).toFixed(2),
                propsName: "taxFinishPrice2",
              },
              // ]
              // }
            ],
          },
          {
            width: null,
            style: {
              flexDirection: "row",
              flex: "none",
              width: "8%",
              // height: '24mm'
            },
            // contentStyle: { flex: "none", width: "20%" },
            // children: [
            // {
            // 	width: null,
            // 	text: '申请扣款'
            // },
            // {
            children: [
              {
                textStyle: zoomStyle,
                text: (item.applyDebitPriceTotal || 0).toFixed(2),
                propsName: "taxFinishPrice1",
              },
              {
                textStyle: zoomStyle,
                text: (item.applyDebitTotal || 0).toFixed(2),
                propsName: "taxFinishPrice2",
              },
            ],
            // }
            // ]
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: (item.applyFreeChargeTotal || 0).toFixed(2),
            propsName: "shipmentDate",
          },
          {
            textStyle: zoomStyle,
            width: null,
            text: ``,
            propsName: "shipmentDate",
          },
          {
            style: {
              width: "40mm",
              flex: "none",
            },
            textStyle: {
              ...zoomStyle,
              lineHeight: "13px",
            },
            width: null,
            text: ``,
          },
        ],
      };
    }
  }
  render(h) {
    return (
      <div class="container">
        <div class="excipient-print">
          <div class="excipient-print__item">
            <print-head
              {...{
                props: {
                  company: {
                    vendorName: this.defailInfo.vendorName,
                    debitOrderNo: this.defailInfo.debitOrderNo,
                  },
                },
              }}
            />

            {this.list.map((item, index) => {
              return (
                <div
                  class={
                    index > 0 && index <= this.list.length - 1
                      ? "excipient-print__item"
                      : ""
                  }
                >
                  <multiline-print
                    {...{
                      props: {
                        info: item.table2,
                      },
                    }}
                  ></multiline-print>
                </div>
              );
            })}
            <print-footer
              {...{
                props: {
                  createByName: this.defailInfo.createByName,
                  statisticalExaminerReplyName: this.defailInfo.statisticalExaminerReplyName,
                  businessReplyName: this.defailInfo
                    .businessReplyName,
                  productManagerReplyName: this.defailInfo
                    .productManagerReplyName,
                    createDate: this.$utils.formatTime(this.defailInfo.createDate),
                    productManagerReplyDate: this.$utils.formatTime(this.defailInfo.productManagerReplyDate),
                    statisticalExaminerReplyDate: this.$utils.formatTime(this.defailInfo.statisticalExaminerReplyDate),
                    businessReplyDate: this.$utils.formatTime(this.defailInfo.businessReplyDate),
                },
              }}
            />
          </div>

          {
          //   this.printNode === 1 && this.businessList.map((item, index) => {
          //   return (
          //     <div class="excipient-print__item">
          //       <p>单号：{this.defailInfo.debitOrderNo}</p>
          //       <multiline-print
          //         {...{
          //           props: {
          //             info: item.table3,
          //           },
          //         }}
          //       ></multiline-print>
          //     </div>
          //   );
          // })
          }
        </div>
      </div>
    );
  }
}
</script>


<style lang="scss" scoped>
.container {
  width: 100%;
  position: absolute;
  top: 0;
}
@media print {
  .excipient-print__item {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
    padding: 18px;
    padding-bottom: 0;
  }
}
.excipient-print__item {
  margin-bottom: 6mm;
  page-break-inside: avoid !important;
    page-break-before: unset !important;
}
</style>